import { makeStyles, Theme } from '@material-ui/core/styles'
import { createStyles } from '@material-ui/core'
import { colorAccentTeal } from '../../../shared/style-settings'

export const useNonprofitDetailsComponentStyles = makeStyles((theme: Theme) =>
  createStyles({
    similarNonprofitsSection: {
      //paddingLeft: 30,
      //paddingRight: 30,
    },
    imgSize: {
      width: '90%',
      height: '382px',
    },
    imgPositioningInContainer: {
      display: 'flex',
      flexDirection: 'row',
    },
    imageBackground: {
      width: '90%',
      height: '382px',
      minHeight: '250px',
      backgroundSize: 'contain',
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat',
      borderRadius: '4px',
      [theme.breakpoints.down('md')]: {
        width: '100%',
        maxWidth: '100%',
        height: '300px',
        minHeight: '200px',
      },
      [theme.breakpoints.down('xs')]: {
        height: '250px',
        minHeight: '180px',
      },
    },
    details: {
      width: '100%',
      padding: '12px 0 0 0',
      marginLeft: '2%',
      [theme.breakpoints.down('md')]: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
      },
    },
    mainHolder: {
      textAlign: 'left',
      overflow: 'hidden',
      position: 'relative',
      padding: `${theme.spacing(6)}px ${theme.spacing(4)}px`,
      marginTop: theme.spacing(4),
    },
    nonprofitListedItemsButton: {
      borderColor: colorAccentTeal,
      color: colorAccentTeal,
      textTransform: 'none',
      borderRadius: '20px',
      width: '100%',
      marginTop: '4em',
    },
    bold: {
      fontWeight: 'bold',
    },
  })
)
